export enum EnumStatusRun {
  scheduled = 'Agendada',
  running = 'Em Andamento',
  finished = 'Finalizada',
  canceled = 'Cancelada',
  rejected = 'Rejeitada',
  shared = 'Compartilhada',
  paid = "Pago"
}
